import { slot_games } from "../../constants/slot_games.js";
import { lastJackpotWinner } from "../../js/api/jackpot.js";
import { userData } from "../../js/api/profile.js";
import IframeModal from "../components/IframeModal.js";
import { getCurrentBalance, updatecasinocurrency } from "../../js/api/balance.js";
import { getGamesList, registerDeluxeCasino, loginDeluxeCasino } from "../../js/api/deluxecasino.js"
import { _t } from "../../services/TranslationService.js";

let Deluxe = {
  render: async () => {
    const lastJackpotWinnerLabel = await lastJackpotWinner();

    let getGames = await getGamesList();

    let group = getGames.gamelist.reduce((r, a) => {
      r[a.Platform] = [...r[a.Platform] || [], a];
      return r;
     }, {});


    let baseUrlIcons = getGames.baseURL;
    let groupView = ``;
    let groupBtnView = `<div class="groupFamilyBtn active" data-btn-target="all"><span class="">${_t('All games')}</span></div>`;
    $.each(group, function(i,item){
    
      let gamesItemView = ``;
      groupBtnView += `
        <div class="groupFamilyBtn" data-btn-target="${i.replaceAll(' ', '')}"><span class="">${i}</span></div>
      `;
      for (const key in item) {
    
        if (Object.hasOwnProperty.call(item, key)) {
          const element = item[key];
      
          gamesItemView += `
            <div class="game animation-element" game="${element.ID}">
              <img src="${baseUrlIcons}${element.GameIconUrl}" onerror="javascript:this.src='./img/games_icons/duser.jpg'">
              <span>${element.Name}</span>
            </div>
          `;
        }
      }
      groupView += `
            <div class="groupGame active elementGroupGame ${(item[0].Platform).replaceAll(' ', '')}">
              ${gamesItemView}
            </div>
      `;
    })
    
    
    let view = /*html*/ `
         <div class="modalHelperHolder">
            <div class="modalHelperPosition">
                <span>Zgjedh monedhen per casino</span>
                <select id="coinSelectorSelect">
                </select>
                <a class="submitBtn modalHandler" id="submitCoinSelected">Vazhdo</a>
            </div>
        </div>

        <h1 class="deluxeTitle" >Welcome To Deluxe Games</h1>
       <div class="slotsCatHolder">
            <div class="slotsCatHelper" id="slotsCatBtn">
              ${groupBtnView}
            </div>
       </div>
       <div class="slotsMainWrapper">
            <div id="main">
              ${groupView}
            </div>

          <script type="text/javascript" src="//ajax.googleapis.com/ajax/libs/jquery/1.11.1/jquery.min.js"></script>
          <script type="text/javascript" src="//ajax.googleapis.com/ajax/libs/swfobject/2.2/swfobject.js"></script>
          <script type="text/javascript">

          </script>
          
          <div id="overlay"></div>
          <iframe id="iframeSlot" src="" ></iframe>
          <div id="game_container">
            <div id="game_flash"></div>
          </div>
       </div>
       `;
    return view;
  },
  after_render: async () => {
    const userDataBody = await userData(localStorage.getItem("user_id"));
    if (!$("body").hasClass("bg-black")) {
      $("body").addClass("bg-black");
    }

    $("body").click(function (e) {
      if (!$(e.target).is(".modalHelperPosition,.modalHelperPosition *")) {
        $(".modalHelperHolder").removeClass("active");
      }
    });

    setCurrentBalanceForSlots();

    jackpotMainAnimation();
    jackpotSecondAnimation();
    jackpotThirdAnimation();

    setInterval(jackpotMainAnimation, $(".jackpotMain .light").length * 75);
    setInterval(jackpotSecondAnimation, $(".jackpotSecond .light").length * 70);
    setInterval(jackpotThirdAnimation, $(".jackpotThird .light").length * 70);

    function jackpotMainAnimation() {
      $(".jackpotMain .light").each(function (i, el) {
        setTimeout(function () {
          $(el).addClass("active");
          setTimeout(function () {
            $(el).removeClass("active");
          }, 155);
        }, i * 70);
      });
    }
    function jackpotSecondAnimation() {
      $(".jackpotSecond .light").each(function (i, el) {
        setTimeout(function () {
          $(el).addClass("active");
          setTimeout(function () {
            $(el).removeClass("active");
          }, 155);
        }, i * 70);
      });
    }
    function jackpotThirdAnimation() {
      $(".jackpotThird .light").each(function (i, el) {
        setTimeout(function () {
          $(el).addClass("active");
          setTimeout(function () {
            $(el).removeClass("active");
          }, 155);
        }, i * 70);
      });
    }

    $("body .machineBoxesHolder").slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: true,
      variableWidth: true,
      dots: false,
      prevArrow: false,
      nextArrow: false,
      centerPadding: "20px",
    });

    var mainIndex = 0;
    let groupContent = "";

    for (let index = 0; index < slot_games.length; index++) {
      let content = "";
      const element = slot_games[index];
      for (let i = 0; i < element.Data.length; i++) {
        const e = element.Data[i].name;
        const id = element.Data[i].id
          ? element.Data[i].id
          : element.Data[i].name;
        // content += `<div class="game" familyid="${element.Type}" game="${e}"><span>${e}</span></div>`;
        content += `<div class="game animation-element" game="${id}"><img src="./img/games_icons/${id}.jpg" onerror="javascript:this.src='./img/games_icons/duser.jpg'"><span>${e}</span><svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enable-background="new 0 0 512 512" height="18" viewBox="0 0 512 512" width="18"><g><path d="m376 31c-54.544 0-95.017 33.497-120 81.015-24.981-47.515-65.454-81.015-120-81.015-78.609 0-136 66.015-136 146.515 0 106.457 101.572 173.291 246.122 299.773 5.657 4.949 14.099 4.948 19.756 0 144.417-126.366 246.122-193.303 246.122-299.773 0-80.513-57.4-146.515-136-146.515zm-120 415.101c-133.122-115.635-226-179.872-226-268.586 0-66.424 45.57-116.515 106-116.515 58.252 0 94.351 53.947 105.542 93.996 4.036 14.61 24.83 14.675 28.916 0 11.043-39.518 46.723-93.996 105.542-93.996 60.43 0 106 50.091 106 116.515 0 88.765-93.03 153.083-226 268.586z"></path></g></svg></div>`;
        // content += `<div class="game" game="${id}"><img src="/bettting_app/user/src/img/games_icons/${id}.jpg" /><span>${e}</span></div>`;
      }

      // if (mainIndex == 0) {
      //   $("body #slotsCatBtn").append(
      //     `<div class="groupFamilyBtn active" data-btn-target="${element.Type}"><span class="">${element.Type}</span></div>`
      //   );
      //   groupContent += `<div class="groupGame active ${element.Type}">${content}</div>`;
      // } else {
      //   if (element.Type !== "GAMINATOR-NOVOMATIC") {
      //     $("body #slotsCatBtn").append(
      //       `<div class="groupFamilyBtn" data-btn-target="${element.Type}"><span class="">${element.Type}</span></div>`
      //     );
      //     groupContent += `<div class="groupGame ${element.Type}">${content}</div>`;
      //   }
      // }

      mainIndex++;
    }

    let catLengthWidth = 0;
    $(".groupFamilyBtn ").each(function (e) {
      catLengthWidth += $(this).outerWidth();
    });
    $("body .slotsCatHelper").css({
      width: catLengthWidth + 3 + "px",
    });

    // $("#main").html(groupContent);

    $("body").on("click", ".groupFamilyBtn", function (e) {
      let eventTarget = $(e.currentTarget).attr("data-btn-target");
      $("body .groupFamilyBtn").removeClass("active");
      $("body .groupGame").removeClass("active");
      $(e.currentTarget).addClass("active");
      if (eventTarget === 'all') {
        $('.groupGame').addClass('active');
      } else {
        $("body ." + eventTarget + "").addClass("active");
      }
    });

    $("body").on("click", "#submitCoinSelected", async function (e) {
      const res = await updatecasinocurrency($("#coinSelectorSelect").val());
      alert("Monedha u vendos, vazhdoni te luani!!");
      callSliderEvent();
    });

    $("body").on("click", ".machineBox", function (e) {
      if (
        !localStorage.getItem("access_token") ||
        localStorage.getItem("access_token") == ""
      ) {
        alert("Login!");
        return;
      }
      if (userDataBody.casinoEnabled != "1") {
        alert("Nuk keni qasje ne lojet e Casino!");
        return;
      }
      const gameName = $(e.currentTarget).attr("game");
      const gameLink = `${location.origin}/casino/index?game=${gameName}&u=${localStorage.getItem(
        "access_token"
      )}&sign=${btoa(localStorage.getItem('user_id'))}`;
      // IframeModal.loadIframe(gameLink);
      // IframeModal.show(gameName);
      // window.location.href = gameLink;

      if (location.host == 'eccoplay365.com') {
        IframeModal.loadIframe(gameLink, true);
        IframeModal.show(gameName);
      } else {
        window.location.href = gameLink;
      }
    });

    

    $(".game").on("click",async function (e) {
      if (
        !localStorage.getItem("access_token") ||
        localStorage.getItem("access_token") == ""
      ) {
        alert("Login!");
        return;
      }

      if (userDataBody.casinoEnabled != "1") {
        alert("Nuk keni qasje ne lojet e Casino!");
        return;
      }

      let hasDeluxe = localStorage.getItem("hasDeluxe");

      console.log(hasDeluxe, 'asdasd')
      if( hasDeluxe === null){
        let register = await registerDeluxeCasino();
      }

      let loginCasinoDeluxe = await loginDeluxeCasino();
      let casinoJwt = loginCasinoDeluxe.jwt;

      $(e.currentTarget).addClass("clicked");
      let gameName = $(e.currentTarget).attr('game');
  
      setTimeout(function () {
        const gameLink = `${location.origin}/gs/startgame?game_id=${gameName}&jwt=${casinoJwt}&sign=${btoa(localStorage.getItem('user_id'))}`;

        IframeModal.loadIframe(gameLink, true);
        IframeModal.show(gameName);
        $(e.currentTarget).removeClass("clicked");
      }, 2000);
    });
  },
};

async function setCurrentBalanceForSlots() {
  var currentBalanceResult = await getCurrentBalance();

  if (currentBalanceResult.casino_currency) return;

  var coins = [];

  if (currentBalanceResult && currentBalanceResult.total_coins) {
    var allCoins = currentBalanceResult.total_coins.split("|");

    if (currentBalanceResult.total_coins.includes("|")) {
      var allCoins = currentBalanceResult.total_coins.split("|");

      for (let index = 0; index < allCoins.length; index++) {
        const coin = allCoins[index];
        const currency = coin.split(";")[0].split(".")[1];
        coins.push({
          currency,
          id: coin.split(";")[0].split(".")[0],
        });

        const value = coin.split(";")[1];
      }
    } else {
      if (currentBalanceResult.currency) {
        coins.push({
          currency: currentBalanceResult.currency,
          id: currentBalanceResult.currency_id,
        });
      } else {
        const currency = currentBalanceResult.total_coins
          .split(";")[0]
          .split(".")[1];
        coins.push({
          currency,
          id: currentBalanceResult.total_coins.split(";")[0].split(".")[0],
        });
      }
    }
  }

  renderCoins(coins);
  callSliderEvent();
}

async function renderCoins(coins) {
  coins.forEach((element) => {
    $("#coinSelectorSelect").append(`<option value="${element.id}"> 
       ${element.currency}   
 </option>`);
  });
}

function callSliderEvent() {
  if ($("body .modalHelperHolder").hasClass("active")) {
    $("body .modalHelperHolder").removeClass("active");
  } else {
    $("body .modalHelperHolder").addClass("active");
  }
}

export default Deluxe;
